<div class="main-container">
  <h2 class="page-header">Whitelisted IP Addresses</h2>
  <!-- Header with Filter Controls -->
  <div class="toolbar">
    <div class="toolbar-left">
      <div class="filter-controls-container">
        <!-- Choose filtered field -->
        <div ngbDropdown #filterDropdown="ngbDropdown" class="filter-field-selector">
          <button id="dropdownMenu" ngbDropdownToggle class="filter-input-container" (click)="onFilterDropdownClick(filterDropdown, $event)">
            <span>Filter by {{ filterField }}</span>
            <span class="chev"><app-chevron-down-icon color="var(--orange-400)" width="24" height="24"></app-chevron-down-icon></span>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownMenu" class="dropdown-menu-panel scrollable-list">
            <ng-container *ngFor="let filterKey of filterFieldOptions">
              <button ngbDropdownItem (click)="putFilterField(filterKey)" class="dropdown-item">
                {{ filterKey }}
              </button>
            </ng-container>
          </div>
        </div>
        
        <!-- Choose filtered value -->
        <div class="filter-value-area">
          <!-- Date Range Picker -->
          <ng-container *ngIf="currentFilterType === FilterType.DATE_RANGE">
            <div class="filter-input-container date-range-picker">
              <button 
                type="button" 
                class="date-range-trigger"
                (click)="toggleDatePicker()"
                [attr.aria-expanded]="showDatePicker">
                <span>{{ getDateRangeDisplayText() }}</span>
                <span class="chev"><app-chevron-down-icon color="var(--grey-500)" width="24" height="24"></app-chevron-down-icon></span>
              </button>

              <div class="date-range-panel" *ngIf="showDatePicker">
                <div class="date-range-sidebar">
                  <div class="date-range-options">
                    <button 
                      *ngFor="let option of dateRangeOptions"
                      type="button"
                      class="date-range-option"
                      [class.active]="selectedDateRange === option.value"
                      (click)="selectPredefinedDateRange(option.value)">
                      {{ option.label }}
                    </button>
                  </div>
                </div>
                
                <div>
                  <div class="date-range-calendar">
                      <div class="calendar-left">
                        <ngb-datepicker
                          #leftDatePicker
                          [displayMonths]="1"
                          [dayTemplate]="dayTemplate"
                          [markDisabled]="markDisabled"
                          outsideDays="visible"
                          [showWeekNumbers]="false"
                          [firstDayOfWeek]="7"
                          navigation="arrows"
                          [startDate]="leftCalendarDate!"
                          [minDate]="minSelectableDate"
                          [maxDate]="maxSelectableDate"
                          (navigate)="onLeftCalendarNavigate($event)"
                          (dateSelect)="onDateSelection($event)">
                        </ngb-datepicker>
                      </div>
                      <div class="calendar-right">
                        <ngb-datepicker
                          #rightDatePicker
                          [displayMonths]="1"
                          [dayTemplate]="dayTemplate"
                          [markDisabled]="markDisabled"
                          outsideDays="visible"
                          [showWeekNumbers]="false"
                          [firstDayOfWeek]="7"
                          navigation="arrows"
                          [startDate]="rightCalendarDate!"
                          [minDate]="leftCalendarMinDate || minSelectableDate"
                          [maxDate]="maxSelectableDate"
                          (navigate)="onRightCalendarNavigate($event)"
                          (dateSelect)="onDateSelection($event)">
                        </ngb-datepicker>
                      </div>
                      <ng-template #dayTemplate let-date="date" let-focused="focused">
                        <span 
                          class="custom-day"
                          [class.focused]="focused"
                          [class.middle-date]="isMiddleDate(date)"
                          [class.start-date]="isStartDate(date)"
                          [class.end-date]="isEndDate(date)"
                          (mouseenter)="onDateHover(date)"
                          (mouseleave)="hoveredDate = null">
                          {{ date.day }}
                        </span>
                      </ng-template>
                  </div>
                  <div class="date-range-actions">
                      <button type="button" class="date-apply-btn" [class.active]="isValidDateRange()" [disabled]="!isValidDateRange()"
                      (click)="applyCurrentFilter()">Apply</button>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Dropdown Picker -->
          <ng-container *ngIf="currentFilterType === FilterType.DROPDOWN">
            <div ngbDropdown #filterDropdown="ngbDropdown" class="filter-input-container" autoClose="outside" 
                (openChange)="$event && onFilterValueDropdownOpen()">
              <button ngbDropdownToggle class="date-range-trigger">
                <span>Select Value</span>
                <span class="chev">
                  <app-chevron-down-icon color="var(--grey-500)"></app-chevron-down-icon>
                </span>
              </button>
              <div ngbDropdownMenu class="dropdown-menu-panel">
                <div class="dropdown-search">
                  <input type="text" placeholder="Search" [(ngModel)]="searchTextInDropdownMenu" (input)="searchInDropdownMenu()"
                    aria-label="Search columns" />
                  <span aria-hidden="true">
                    <i class="pe-7s-search" style="color: var(--orange-400); font-size: 16px;"></i>
                  </span>
                </div>

                <div class="dropdown-actions">
                  <button type="button" (click)="selectAllMenuItems()">Select All</button>
                  <button type="button" (click)="deselectAllMenuItems()">Deselect All</button>
                  <button type="button" (click)="toggleShowSelectedMenuItem()">{{ showSelectedMenuItem ? 'Show All' : 'Show Selected' }}</button>
                </div>
            
                <div class="divider"></div>
            
                <div class="recursive-menu-scrollable-list">
                  <ng-container *ngFor="let option of currentDropdownOptions">
                    <ng-container *ngTemplateOutlet="dropdownItemTemplate; context: { $implicit: option, level: 0 }"></ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Text Input -->
          <ng-container *ngIf="currentFilterType === FilterType.TEXT_INPUT">
            <div class="filter-input-container">
              <input 
                type="text" 
                [(ngModel)]="textInputFilter" 
                placeholder="Enter Value"
                [attr.aria-label]="'Enter Value of ' + filterField"
                (input)="applyCurrentFilter()">
              <span aria-hidden="true">
                <i class="pe-7s-search" style="color: var(--grey-500); font-size: 16px;"></i>
              </span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="toolbar-right">
      <div class="export-dropdown">
        <button type="button" class="export-button" (click)="openAddIpDialog()">
          <span>Add IP Address</span>
        </button>
      </div>

      <div class="export-dropdown">
        <button type="button" class="export-button" (click)="openHistoryPanel()" [disabled]="isAdminGated">
          <span>History</span>
        </button>
      </div>

      <div class="export-dropdown">
        <button type="button" class="export-button" (click)="exportIPWhitelist()" [disabled]="isAdminGated">
          <span>Export</span>
        </button>
      </div>

      <!-- Customize -->
      <div class="customize-dropdown">
        <button type="button" class="customize-trigger" [class.open]="showCustomize"
          (click)="toggleCustomizeDropdown()" [attr.aria-expanded]="showCustomize" aria-haspopup="true"
          aria-label="Customize columns">
          <span>Customize</span>
          <span class="chev">
            <app-chevron-down-icon width="24" height="24" color="var(--orange-400)"></app-chevron-down-icon>
          </span>
        </button>

        <div class="customize-panel" *ngIf="showCustomize" [attr.tabindex]="0" aria-label="Customize columns">
          <div class="dropdown-search">
            <input type="text" placeholder="Search" [(ngModel)]="customizeSearch" aria-label="Search columns" />
            <span aria-hidden="true">
              <i class="pe-7s-search" style="color: var(--orange-400); font-size: 16px;"></i>
            </span>
          </div>

          <div class="dropdown-actions">
            <button type="button" (click)="selectAllColumns()">Select All</button>
            <button type="button" (click)="deselectAllColumns()">Deselect All</button>
            <button type="button" (click)="toggleShowSelectedFieldsOnly()">{{ showSelectedFieldsOnly ? 'Show All' : 'Show Selected' }}</button>
          </div>

          <div class="divider"></div>

          <div class="scrollable-list">
            <div class="dropdown-item" *ngFor="let col of filteredColumns; let i = index">
              <span class="drag-handle" aria-hidden="true"><span></span><span></span><span></span></span>
              <input type="checkbox" [id]="'col-' + ($any(col).colId || i)" [checked]="!col.hide"
                (change)="onToggleColumnById($any(col).colId, $any($event.target).checked)" />
              <label [for]="'col-' + ($any(col).colId || i)">{{ col.headerName || col.field || ('Column ' + (i + 1)) }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Filter Badges -->
  <div class="badge-row" *ngIf="getFiltersArray().length > 0">
    <div class="badges">
      <ng-container *ngFor="let filter of getFiltersArray(); trackBy: trackByFilter" >
        <span class="badge badge-orange">
          <span class="badge-text">{{ getFilterDisplayText(filter[0], filter[1]) }}</span>
          <button class="badge-x" (click)="removeFilter(filter[0]); $event.stopPropagation(); $event.preventDefault()" aria-label="Remove filter badge">✕</button>
        </span>
      </ng-container>
      <div class="badge-meta" *ngIf="filters.size > 0">
        <span>Filtered {{ totalItems }} out of {{ totalItemsWithoutFilters }}</span>
        <button class="link" (click)="clearAllFilters()">Clear All Filters</button>
      </div>
    </div>
  </div>

  <!-- IP Whitelist table -->
  <div class="card">
    <div class="ag-grid-container">
      <div class="ag-theme-alpine">
        <ag-grid-angular style="width: 100%; height: 100%;"
          [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [rowData]="ipWhitelistData" [pagination]="true"
          [paginationPageSize]="rowsPerPage" [suppressPaginationPanel]="true" [suppressRowClickSelection]="true"
          [rowSelection]="'multiple'" [theme]="'legacy'" [getRowId]="getRowId" (gridReady)="onGridReady($event)"
          [enableCellTextSelection]="true" [suppressDragLeaveHidesColumns]="true" [suppressMovableColumns]="false"
          [overlayNoRowsTemplate]="noRowsTemplate"> 
        </ag-grid-angular>
        
        <!-- Actions dropdown menu positioned absolutely -->
        <div class="actions-menu-container" *ngIf="openedActionRowId !== null && selectedRow">
          <div class="actions-menu" [style.top.px]="actionMenuPosition.top" [style.left.px]="actionMenuPosition.left">
            <button class="action-item" (click)="onEditAction()">Edit</button>
            <button class="action-item" (click)="onDisableAction()">Disable</button>
          </div>
        </div>
      </div>
    </div>
    <!-- NgBootstrap pagination as card footer -->
    <div class="pager">
      <div class="pager-left">
        Showing <span class="high-light">{{ getItemRangeInPage() }}</span> out of <span class="high-light">{{ totalItems }}</span>
      </div>

      <div class="pager-center">
        <ngb-pagination [(page)]="currentPage" [pageSize]="rowsPerPage" [collectionSize]="totalItems" [maxSize]="5"
          [rotate]="false" [boundaryLinks]="true" [directionLinks]="true" [ellipses]="false"
          (pageChange)="onPageChange($event)">
        </ngb-pagination>
      </div>

      <div class="pager-right">
        <span class="muted">Show rows</span>
        <select [ngModel]="rowsPerPage" (ngModelChange)="changeRowsPerPage($event)" name="rowsPerPage">
          <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{size}}</option>
        </select>
      </div>
    </div>
  </div>

  <!-- Access Notice -->
  <div class="access-notice" *ngIf="isViewOnlyAccess">
    <i class="pe-7s-info"></i>
    <span>You have view-only access. Contact your Merchant Admin to request edit access.</span>
  </div>
</div>

<!-- IP Whitelist Dialog -->
<app-ip-whitelist-dialog
  [(isVisible)]="isIpDialogVisible"
  [mode]="ipDialogMode"
  [ipData]="selectedIpData"
  [merchantName]="selectedIpData?.merchantName || ''"
  [merchantId]="selectedIpData?.merchantId || ''"
  [showMerchantInfo]="role === Role.PAY10_ADMIN && ipDialogMode === 'edit'"
  [showMerchantSearch]="role === Role.PAY10_ADMIN && ipDialogMode === 'add'"
  (success)="handleIpDialogSuccess()"
  (failed)="handleIpDialogFailed($event)"
  (closed)="handleIpDialogClose()">
</app-ip-whitelist-dialog>

<!-- Right-side History Drawer -->
<div class="history-backdrop" *ngIf="showHistoryPanel" (click)="onHistoryBackdrop($event)" (keydown.escape)="closeHistoryPanel()">
  <aside class="history-panel" (click)="$event.stopPropagation()" aria-label="History panel">
    <header class="history-header">
      <h3>History</h3>
    </header>

    <div class="history-scroll" #historyScrollContainer (scroll)="onHistoryScroll()">
      <ng-container *ngFor="let item of historyItems">
        <div class="history-item">
          <div class="history-action" [ngClass]="getHistoryTypeLabel(item).toLowerCase()">{{ getHistoryTypeLabel(item) }}</div>
          <div class="history-message" [innerHTML]="getHistoryMessageHTML(item)"></div>
          <div class="history-datetime">{{ formatHistoryTime(item) }}</div>
          <div class="history-actor" *ngIf="getHistoryActor(item)">By {{ getHistoryActor(item) }}</div>
        </div>
      </ng-container>

      <div class="history-loading" *ngIf="historyLoading">Loading…</div>
      <div class="history-empty" *ngIf="!historyLoading && historyItems.length === 0">No history yet</div>
      <div class="history-end" *ngIf="!historyLoading && !historyHasMore && historyItems.length > 0">End of history</div>
    </div>

    <footer class="history-actions">
      <button type="button" class="export-button" (click)="exportHistory()">Export</button>
      <button type="button" class="close-button" (click)="closeHistoryPanel()">Close</button>
    </footer>
  </aside>
  
</div>

<!-- Recursive template for nested dropdown items -->
<ng-template #dropdownItemTemplate let-option let-level="level">
  <div class="dropdown-item" *ngIf="option.visible" [style.padding-left.px]="level > 0 ? 30 : 8">
    <div class="dropdown-item-content">
      <div class="checkbox-label-container">
        <input 
          type="checkbox" 
          [id]="'checkbox-' + option.value + '-level-' + level" 
          [checked]="option.selected"
          (change)="toggleDropdownFilterValue(option, $event)" />
        <label [for]="'checkbox-' + option.value + '-level-' + level">{{ option.label }}</label>
      </div>

      <button 
        *ngIf="option.hasChildren()" 
        type="button" 
        class="expand-button"
        (click)="toggleItemExpansion(option)"
        [attr.aria-expanded]="option.expanded">
        <i [class]="option.expanded ? 'pe-7s-angle-up' : 'pe-7s-angle-down'" 
           style="color: var(--grey-500, #939598); font-size: 32px; font-weight: 500;"></i>
      </button>
    </div>
    
    <div class="dropdown-children" *ngIf="option.hasChildren() && option.expanded">
      <ng-container *ngFor="let child of option.children">
        <ng-container *ngTemplateOutlet="dropdownItemTemplate; context: { $implicit: child, level: level + 1 }"></ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>
